export const mainTagsNames = [
	'html',
	'css',
	'css-patterns',
	'scss',
	'javascript',
	'webpack',
	'react-js',
	'next-js',
	'styled-components',
	'react-router-dom', 
	'redux',     
	'node-js',
	'mongodb', 
	'mysql', 
	'postgres', 
	'api rest', 
	'jwt',
	'regex',
	'mvc pattern'
];

export const mainTags = [
	{name: 'HTML', count: 0},
	{name: 'CSS', count: 0},
	{name: 'SCSS', count: 0},
  {name: 'CSS-Patterns', count: 0},
	{name: 'JavaScript', count: 0},
  {name: 'WEBPACK', count: 0},
	{name: 'React-JS', count: 0},
	{name: 'Next-JS', count: 0},
	{name: 'Styled-components', count: 0},
	{name: 'React-Router-Dom', count: 0},
	{name: 'Redux', count: 0},
	{name: 'Node-JS', count: 0},
	{name: 'MongoDB', count: 0},
	{name: 'MySQL', count: 0},
	{name: 'Postgres', count: 0},
	{name: 'API REST', count: 0},
	{name: 'JWT', count: 0},
  {name: 'REGEX', count: 0},
  {name: 'MVC Pattern', count: 0},
];


// export const aggregateTags = (tagArr) => {
	// tagArr.forEach((project) => {
		// mainTagsNames.forEach((tag) => {
			// if (project.tags.includes(tag)) {
				// console.log(tag);
				
				// mainTags.forEach((obj) => {
					// if (obj.name.toLowerCase() === tag) {
						// obj.count += 1;
					// }
				// });
			// }
		// });

	// });
	
	// console.log(mainTags);
// };





